/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { OAuthClient } from './OAuthClient';
import {
    OAuthClientFromJSON,
    OAuthClientFromJSONTyped,
    OAuthClientToJSON,
    OAuthClientToJSONTyped,
} from './OAuthClient';

/**
 * 
 * @export
 * @interface ListOauthClientsResponse
 */
export interface ListOauthClientsResponse {
    /**
     * 
     * @type {Array<OAuthClient>}
     * @memberof ListOauthClientsResponse
     */
    data: Array<OAuthClient>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListOauthClientsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListOauthClientsResponse interface.
 */
export function instanceOfListOauthClientsResponse(value: object): value is ListOauthClientsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListOauthClientsResponseFromJSON(json: any): ListOauthClientsResponse {
    return ListOauthClientsResponseFromJSONTyped(json, false);
}

export function ListOauthClientsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOauthClientsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(OAuthClientFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListOauthClientsResponseToJSON(json: any): ListOauthClientsResponse {
      return ListOauthClientsResponseToJSONTyped(json, false);
  }

  export function ListOauthClientsResponseToJSONTyped(value?: ListOauthClientsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(OAuthClientToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

